import type { IOrganizationFeatureComms } from './OrganizationFeatureComms.interface';

export default class OrganizationFeatureComms implements IOrganizationFeatureComms {
  messagesRemaining: number;
  automaticallyRecharge: boolean;
  rechargeWhenSMSRemainingReach: number;

  static build = (data: IOrganizationFeatureComms) => new OrganizationFeatureComms(data);
  static blank = () => new OrganizationFeatureComms();

  /**
   * Constructor
   * @param {IOrganizationFeatureComms} data
   */
  constructor(data?: IOrganizationFeatureComms) {
    this.messagesRemaining = parseInt(data?.messagesRemaining || 0, 10);
    this.automaticallyRecharge = data?.automaticallyRecharge === true;
    this.rechargeWhenSMSRemainingReach = parseInt(data?.rechargeWhenSMSRemainingReach || 0, 10);
  }
}
